import React from 'react';
import PropTypes from 'prop-types';

const NextAvailableButton = ({ onClick }) => (
  <button type="button" className="c-btn c-btn--default c-btn--small u-mt" onClick={onClick}>
    Next Available Time
  </button>
);
NextAvailableButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default NextAvailableButton;



// WEBPACK FOOTER //
// ./src/app/times/components/NextAvailableButton.jsx